import { BID_REBATE_PERCENT } from '@/utils/offers'
import BidIcon from '@/icons/bid'

export default function PlaceBidLabel({ rebate = false }: { rebate?: boolean }) {
 return (
  <span data-place-bid-label className="flex w-full items-center justify-center gap-1.5 leading-none">
   <BidIcon size={14} className="block shrink-0" aria-hidden="true" />
   <span className="block leading-none">Make Offer{rebate && ` • ${BID_REBATE_PERCENT}% Fee Rebate`}</span>
  </span>
 )
}
